const locale = {
	ERROR403: 'Error 403',
	ERROR403TEXT: 'We are not allowed to show you this page.',
	ERROR403SUBTEXT: 'Apparently you do not have authorization or a valid license for this page!',
	ERROR404: 'Error 404',
	ERROR404TEXT: 'Sorry, but we could not find the page you are looking for!',
	BACKTOMAIN: 'Go back to main',
	ERROR500: 'Error 500',
	ERROR500TEXT: 'Oops, something bad just happened!',
	ERROR500SUBTEXT: 'Looks like we have an internal issue, please try again in a couple of minutes.',
	REPORTPROBLEM: 'Report this problem'
};

export default locale;
